import { render, staticRenderFns } from "./editQs.vue?vue&type=template&id=4252103d&scoped=true"
import script from "./editQs.vue?vue&type=script&lang=js"
export * from "./editQs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252103d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4252103d')) {
      api.createRecord('4252103d', component.options)
    } else {
      api.reload('4252103d', component.options)
    }
    module.hot.accept("./editQs.vue?vue&type=template&id=4252103d&scoped=true", function () {
      api.rerender('4252103d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/questionList/editQs.vue"
export default component.exports